import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItem, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Directions = () => {
  const theme = useTheme();

  return (
    <Box className="m-t-16">
      <Accordion disableGutters sx={{ mb: 1 }} defaultExpanded>
        <AccordionSummary sx={{ borderBottom: 1, borderBottomColor: theme.palette.colordee5e7.main }} expandIcon={<ExpandMoreIcon />}>
          <Box className="header-text">Directions</Box>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0, fontSize: '13px', color: theme.palette.color50555b.main }}>
          <List sx={{ listStyleType: 'disc' }}>
            <ListItem>1. For Bloodborne Pathogen training, you have two options:</ListItem>
            <ListItem>
              <ul>
                <li>
                  <span className="bold">Group Setting:</span> Collaborate with colleagues to address questions as they arise.
                </li>
                <li>
                  <span className="bold">Interactive Session:</span> Engage directly with an instructor via our chat feature.
                </li>
              </ul>
            </ListItem>
            <ListItem>
              <span>2. If your office chooses to watch the <span className="bold">OSHA Federal Health and Safety Training Video</span> as a group, follow
              these steps:</span>
            </ListItem>
            <ListItem>
              <ul>
                <li>Watch the video together.</li>
                <li>Pause at the quiz section.</li>
                <li>
                  Each team member should then log in to their individual training video, fast forward to the quiz, and complete it independently.
                </li>
              </ul>
            </ListItem>
            <ListItem>
              3. For any questions during the training, use the chat feature located in the lower right corner of OnTraq. Bloodborne Pathogen training
              must be interactive, allowing immediate opportunities to ask questions as they arise.
            </ListItem>
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Directions;
